/* eslint-disable indent */
import {
  signIn,
  signOut,
  getCurrentUser,
  fetchAuthSession,
  fetchUserAttributes,
  updatePassword,
  resetPassword,
  type ResetPasswordOutput,
  confirmResetPassword
} from 'aws-amplify/auth'
import { Amplify, type ResourcesConfig } from 'aws-amplify'
import { API_USERS } from '../constans/index'

export const authConfig: ResourcesConfig['Auth'] = {
  Cognito: {
    userPoolClientId: String(process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID) ?? '',
    userPoolId: String(process.env.NEXT_PUBLIC_COGNITO_POOL_ID) ?? ''
  }
}

Amplify.configure({
  Auth: authConfig
})

export async function authenticate(email: string, password: string) {
  try {
    await signOut()
    const { isSignedIn, nextStep } = await signIn({
      username: email,
      password
    })
    if (isSignedIn && nextStep.signInStep === 'DONE') {
      const u = await getCurrentUser()
      const session = await fetchAuthSession()
      const userAttributes = await fetchUserAttributes()
      console.log('User attributes:', userAttributes)
      return {
        user: {
          id: u.userId,
          username: userAttributes.email ?? '',
          email: userAttributes.email ?? '',
          name: userAttributes.name ?? '',
          role: userAttributes['custom:role'] ?? ''
        },
        apiToken: session.tokens?.accessToken.toString() ?? '',
        nextStep: nextStep.signInStep
      }
    } else {
      return {
        user: null,
        apiToken: '',
        nextStep: nextStep.signInStep
      }
    }
  } catch (error) {
    console.error('Error during authentication:', error)
    throw new Error('Error during authentication')
    return null
  }
}

export async function confirmUser(email: string, newPassword: string) {
  try {
    const response = await fetch(`${API_USERS}/password`, {
      method: 'POST',
      body: JSON.stringify({
        email,
        new_password: newPassword
      })
    })
    const data = await response.json()
    if (!response.ok) {
      console.error(data)
      throw new Error('Failed to change password')
    }
    console.log(data)
  } catch (error) {
    console.error('Failed to fetch users:', error)
    throw error
  }
}

export async function userChangePassword(email: string, newPassword: string) {
  try {
    const response = await fetch(`${API_USERS}/password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
        // Include authorization header if required
        // 'Authorization': `Bearer ${apiToken}`,
      },
      body: JSON.stringify({
        email,
        new_password: newPassword
      })
    })

    const data = await response.json()

    if (!response.ok) {
      console.error('Failed to change password:', data)
      throw new Error(data.message || 'Failed to change password')
    }

    console.log('Password changed successfully:', data)
    return data // Return data if needed
  } catch (error) {
    console.error('Failed to update user password:', error)
    throw error
  }
}

export async function recoverPassword(email: string) {
  try {
    const output = await resetPassword({ username: email })
    console.log(output)
    handleResetPasswordNextSteps(output)
  } catch (error) {
    console.log(error)
  }
}

function handleResetPasswordNextSteps(output: ResetPasswordOutput) {
  const { nextStep } = output
  const codeDeliveryDetails = nextStep.codeDeliveryDetails
  switch (nextStep.resetPasswordStep) {
    case 'CONFIRM_RESET_PASSWORD_WITH_CODE':
      console.log(`Confirmation code was sent to ${String(codeDeliveryDetails.deliveryMedium)}`)
      // Collect the confirmation code from the user and pass to confirmResetPassword.
      break
    case 'DONE':
      console.log('Successfully reset password.')
      break
  }
}

export async function resetPasswordToken(username: string, confirmationCode: string, newPassword: string) {
  await confirmResetPassword({ username, confirmationCode, newPassword })
}
